import { render } from "./CashRegister.vue?vue&type=template&id=e6e624b0"
import script from "./CashRegister.vue?vue&type=script&lang=js"
export * from "./CashRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__